<script>
/* jshint esversion: 6 */
import {computed, watch, inject } from 'vue';
import './../func.common.js';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'FileUploadSingle',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'disabled': {type: Boolean},
        'hinted': {type:String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props, ctx) {
        const validateChild = inject('validateChild');
        let isDragging = false;
        let checkArray = {
            idLabel: `fileToUpload${props.schema.model}`,
            tdPreview: `td${props.schema.model}`,
            fileUpload: props.schema.fileUpload,
            dragDrop: `drag${props.schema.model}`,
            toParent: {
                'id' : props.schemaId,
                'model': props.schema.model,
                'validator' : props.schema.validator,
            }
        };

        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(() => helperName, (newVal, oldVal) => {
            if (validateChild) {
                validateChild(checkArray.toParent);
            }
        }, {deep: true});

        function fileChange(e) {
            //empty model.files
            props.model[props.schema.model] = [];

            //file Variable
            var files = e.target.files || e.dataTransfer.files; 
            props.model[props.schema.model].push(files);
        }

        return {
            isDragging,
            checkArray,
            fileChange
        }
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fileUploadSingle(
        :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        .form-group.fieldFileUpload
            label 
                | {{ schema.label }}
            .field-wrap(:style="disabled === true ? 'cursor:not-allowed; opacity: 0.5': ''")
                .mb-3  
                input.form-control(
                    type="file" 
                    id="formFilePreVersion"
                    @change="fileChange"
                    :style="disabled === true ? 'pointer-events:none': ''")
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
            template(v-if="schema.errorShow === true")
                br
                .vueFormSmall.labelred(v-if="schema.errorShow === true")
                    font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                    | &nbsp; Fehler in der/den Datei/en
                    ul
                        template(v-for="item in schema.errorText")
                            li(v-html="item")
</template>